"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapInTx = void 0;
const web3_js_1 = require("@solana/web3.js");
const COMPUTE_UNITS_DEFAULT = 200000;
function wrapInTx(instruction, computeUnits = 600000, computeUnitsPrice = 0) {
    const tx = new web3_js_1.Transaction();
    if (computeUnits != COMPUTE_UNITS_DEFAULT) {
        tx.add(web3_js_1.ComputeBudgetProgram.setComputeUnitLimit({
            units: computeUnits,
        }));
    }
    if (computeUnitsPrice != 0) {
        tx.add(web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({
            microLamports: computeUnitsPrice,
        }));
    }
    return tx.add(instruction);
}
exports.wrapInTx = wrapInTx;
